import _ from 'lodash'

import { RouterState } from 'modules/core/hooks/useGetSiteControl'
import SafeJSON from 'modules/core/lib/SafeJSON'
import { track } from 'modules/core/lib/metrics'

import { GraphQLClient } from './graphql/provider'

const stateToString = (state: RouterState) => {
  return _.compact(_.map(state.routes, 'path')).join('/').slice(1)
}

export default function trackTransition(
  graphQLClient: GraphQLClient | null,
  event_type = 'PAGE_TRANSITION',
  payload: object = {}
) {
  const { prevState, nextState } =
    SafeJSON.parse<{ prevState?: RouterState; nextState?: RouterState }>(
      sessionStorage.getItem('rootRouteTransition'),
      {}
    ) || {}

  if (!prevState || !nextState) return

  const prev = stateToString(prevState)
  const next = stateToString(nextState)

  if (next === prev) return

  const event = _.toUpper(_.snakeCase(event_type))

  track(graphQLClient, event, { ...payload, target_path: next, source_path: prev })
}
